/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconRewindForward5 = createReactComponent("outline", "rewind-forward-5", "IconRewindForward5", [["path", { "d": "M9 18a6 6 0 1 1 0 -12h11", "key": "svg-0" }], ["path", { "d": "M13 20h2a1 1 0 0 0 1 -1v-1a1 1 0 0 0 -1 -1h-2v-3h3", "key": "svg-1" }], ["path", { "d": "M17 9l3 -3l-3 -3", "key": "svg-2" }]]);

export { IconRewindForward5 as default };
//# sourceMappingURL=IconRewindForward5.mjs.map
